export enum PartOfDay {
  MORNING = 'MORNING',
  NIGHT = 'NIGHT',
}

export enum DayStage {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete'
}

export enum DayCompletionState {
  FULL = 'full',
  PARTIAL = 'partial',
}
